import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { createContext, useContext } from "react";
import type { LearnDeckOperations } from "#learn-deck-operations-provider";

/** Always provided by `LearnDeckOperationsProvider` (mounted by `LearnDeckHost`); throws outside it. */
// oxlint-disable-next-line no-top/no-top-level-side-effects -- createContext allocates a descriptor without changing external state.
export const LearnDeckOperationsContext = createContext(
  defaultError<LearnDeckOperations>("LearnDeckOperationsContext"),
);

export function useLearnDeckOperations() {
  return useContext(LearnDeckOperationsContext);
}
